import React from 'react'
import { Editor } from '@tinymce/tinymce-react';
import { withStyles, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Container, Snackbar, TextField, Grid, Card, CardContent, Divider, Chip } from '@material-ui/core';
import { addArticle } from '../../Helpers/ArticleHelpers';
import MuiAlert from '@material-ui/lab/Alert';
import { Redirect } from 'react-router';

const styles = theme => ({
    title: {
        fontSize: theme.typography.h2.fontSize,
        border: 'none',
        background: 'none',
        '&:focus': {
            outline: 'none'
        }
    },
    headline: {
        position: 'relative'
    },
    submitButton: {
        position: 'absolute',
        right: '0',
        top: '50%',
    },
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    }
})

class AddArticle extends React.Component {
    state = {
        article: {
            title: '',
            content: '',
            imagePath: null,
            tags: []
        },
        imageDialogOpen: false,
        pdfDialogOpen: false,
        currentTag: '',
        image: null,
        pdf: null,
        snackbar: {
            open: false,
            value: '',
            type: ''
        },
        redirect: false,
        articleId: null,
        submitted: false,
    }

    handleEditorChange = (e) => {
        const content = e.target.getContent();
        const articleData = this.state.article;
        articleData.content = content;
        this.setState({ article: articleData });
    }

    handleTitleChange = (e) => {
        const title = e.target.value;
        const articleData = this.state.article;
        articleData.title = title;
        this.setState({ article: articleData });
    }

    handleSubmit = e => {
        e.preventDefault();
        this.addMissingTag()
        this.setState({ submitted: true });
        addArticle(this.state.article, this.state.image, this.state.pdf).then((articleId) => {
            let snackbarData = this.state.snackbar;
            snackbarData.open = true;
            snackbarData.type = "success";
            snackbarData.value = "Published Successfully.";
            this.setState({ snackbar: snackbarData, articleId });
            // setTimeout(() => this.setState({ redirect: true }), 5000);
        })
        .catch(error => {
            let snackbarData = this.state.snackbar;
            snackbarData.open = true;
            snackbarData.type = "error";
            snackbarData.value = error;
            this.setState({ snackbar: snackbarData });
        });
    }

    handleImageDialogClose = () => {
        this.setState({ imageDialogOpen: false });
    }
    handlePDFDialogClose = () => {
        this.setState({ pdfDialogOpen: false });
    }

    handleImageDialogOpen = () => {
        this.setState({ imageDialogOpen: true });
    }
    handlePDFDialogOpen = () => {
        this.setState({ pdfDialogOpen: true });
    }

    handleImageChange = (e) => {
        const image = e.target.files[0];
        this.setState({ image });
    }
    handlePDFChange = (e) => {
        const pdf = e.target.files[0];
        this.setState({ pdf });
    }

    handleTagChange = (e) => {
        this.setState({ currentTag: e.target.value })
    }

    addTag = (tag) => {
        let article = this.state.article
        if (tag) {
            article.tags.push(tag.trim())
            this.setState({ article })
        }
    }

    handleTagAdd = (e) => {
        if (e.keyCode === 9) { // 9 = "tab" key
            e.preventDefault()
            const tag = e.target.value
            this.addTag(tag)
            this.setState({ currentTag: '' })
        }
    }

    handleTagDelete = (tag) => {
        let article = this.state.article
        article.tags.splice(article.tags.indexOf(tag), 1)
        this.setState(article)
    }

    addMissingTag = () => {
        if (this.state.currentTag && this.state.currentTag.length > 0) {
            this.addTag(this.state.currentTag)
            this.setState({ currentTag: '' })
        }
    }

    handleAuthorChange = (e) => {
        const authorName = e.target.value;
        const articleData = this.state.article;
        articleData.authorName = authorName;
        this.setState({ article: articleData });
    }
    
    renderImageDialog = () => (
        <div>
            <Dialog open={this.state.imageDialogOpen} onClose={this.handleDialogClose} aria-labelledby="image-upload-form">
                <DialogTitle>Upload article image</DialogTitle>
                <DialogContent>
                    <DialogContentText>Upload the image that will represent the article</DialogContentText>
                    <input type="file" accept=".jpg,.png,.gif" onChange={this.handleImageChange} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleImageDialogClose}>Done</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
    renderPDFDialog = () => (
        <div>
            <Dialog open={this.state.pdfDialogOpen} onClose={this.handleDialogClose} aria-labelledby="image-upload-form">
                <DialogTitle>Upload article image</DialogTitle>
                <DialogContent>
                    <DialogContentText>Upload the article in PDF</DialogContentText>
                    <input type="file" accept=".pdf" onChange={this.handlePDFChange} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handlePDFDialogClose}>Done</Button>
                </DialogActions>
            </Dialog>
        </div>
    );

    renderSnackbar = () => {
        return (
            <Snackbar
                open={this.state.snackbar.open}
                autoHideDuration={10000}
                onClose={this.handleSnackbarClose}>
                    <MuiAlert
                        elevation={6} variant="filled" color={this.state.snackbar.type} onClose={this.handleSnackbarClose}>
                            {this.state.snackbar.value}
                        </MuiAlert>
            </Snackbar>
        )
    }

    renderRedirect = () => {
        if (this.state.redirect && this.state.articleId) {
            return (
                <Redirect to={`/articles/edit/${this.state.articleId}`} />
            )
        }
    }

    render() {
        const { classes } = this.props;
        const tags = this.state.article.tags
        return (
            <div>
                <Container maxWidth="xl">
                    {this.renderRedirect()}
                    {this.renderSnackbar()}
                    {this.renderImageDialog()}
                    {this.renderPDFDialog()}
                    <form onSubmit={this.handleSubmit}>
                        <Grid container spacing={4}>
                            <Grid item md={8}>

                                <div className={classes.headline}>
                                    <input
                                        type="text" 
                                        className={classes.title}
                                        value={this.state.article.title}
                                        onChange={this.handleTitleChange}
                                        placeholder="Title"/>
                                    <div className={classes.submitButton} >
                                        
                                    </div>
                                </div>
                            </Grid>
                            <Grid item md={4}>
                                <Card>
                                    <CardContent>
                                        <Button
                                            type="submit" 
                                            disabled={this.state.submitted}
                                            color="primary"
                                            variant="contained">
                                                Publish
                                        </Button>
                                        
                                        <Divider className={classes.divider} />
                                        
                                        <Button
                                            type="button" 
                                            color="primary"
                                            onClick={this.handleImageDialogOpen}
                                            variant="outlined">
                                                Add image
                                        </Button>
                                        <Button
                                            type="button" 
                                            color="primary"
                                            onClick={this.handlePDFDialogOpen}
                                            variant="outlined">
                                                Add PDF
                                        </Button>
                                        
                                        <Divider className={classes.divider} />

                                        <TextField
                                        type="text" 
                                        fullWidth
                                        value={this.state.article.authorName}
                                        onChange={this.handleAuthorChange}
                                        placeholder="Author name"/>

                                        <Divider className={classes.divider} />
                                        
                                        <TextField 
                                            placeholder="Tag"
                                            fullWidth
                                            value={this.state.currentTag}
                                            onChange={this.handleTagChange}
                                            onKeyDown={this.handleTagAdd}
                                            helperText="Enter the tag then press TAB to add another one" />
                                        {tags && tags.map(tag => (
                                            <Chip 
                                                key={tags.indexOf(tag)}
                                                label={tag}
                                                color="primary"
                                                variant="outlined"
                                                onDelete={() => this.handleTagDelete(tag)} />
                                        ))}
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
            </div>
        )
    }
}

export default withStyles(styles)(AddArticle);